import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router';

function VendorCard(props) {
   var { vendor, onEdit, onDelete, history } = props;

   // Helper to format date (Jun 15, 2025)
   const formatDate = (dateStr) => {
      return moment(dateStr).format('MMM D, YYYY');
   };

   const redirectToDetails = () => {
      history.push(`/hr/vendors/${vendor.id}`);
   }

   return (
      <div
         className={'vendors__data-card ' + (vendor.active ? 'status-active' : 'status-inactive')}
         onClick={() => {
            redirectToDetails();
         }}
      >
         <div className="vendors__card-header-row">
            <div className="vendors__card-name">
               <span className={'vendors__status-dot ' + (vendor.active ? 'active' : 'inactive')}></span>
               {vendor.name}
            </div>

            <span className={vendor.active ? 'vendors__badge-active' : 'vendors__badge-inactive'}>
               {vendor.active ? 'Active' : 'Inactive'}
            </span>
         </div>

         <div className="vendors__card-meta">
            <div className="vendors__card-meta-item">
               <div className="vendors__card-meta-label">Contact Email</div>
               <div className="vendors__card-meta-value">{vendor.contact_email}</div>
            </div>

            <div className="vendors__card-meta-item">
               <div className="vendors__card-meta-label">Drivers</div>
               <div className="vendors__card-meta-value">{vendor.user_count}</div>
            </div>

            <div className="vendors__card-meta-item">
               <div className="vendors__card-meta-label">Status</div>
               <div className="vendors__card-meta-value">
                  <span className={'vendors__status-dot ' + (vendor.active ? 'active' : 'inactive')}></span>
                  {vendor.active ? 'Active' : 'Inactive'}
               </div>
            </div>

            <div className="vendors__card-meta-item">
               <div className="vendors__card-meta-label">Date Created</div>
               <div className="vendors__card-meta-value">{formatDate(vendor.date_created)}</div>
            </div>
         </div>

         <div className="vendors__card-actions">
            <button
               className="btn-hover"
               onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  redirectToDetails();
               }}
               title="View Details"
            >
               View <i className="fa fa-eye" style={{ height: '0.8rem' }}></i>
            </button>
            <button
               className="btn-hover"
               onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onEdit(vendor);
               }}
               title="Edit"
            >
               Edit <i className="fa fa-pencil" style={{ height: '0.8rem' }}></i>
            </button>
            <button
               className="btn-hover"
               onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onDelete(vendor);
               }}
               title="Delete"
               style={{ color: '#dc3545' }}
            >
               Delete <i className="fa fa-trash" style={{ height: '0.8rem' }}></i>
            </button>
         </div>
      </div>
   );
}

export default withRouter(VendorCard);
